module.exports = __webpack_public_path__ + "static/media/diagonal-arrow.157e6b30.svg";